import { FleekError } from './FleekError';

type InvalidRecoveryCodeErrorOptions = {
  code: string;
};

export class InvalidRecoveryCodeError extends FleekError<InvalidRecoveryCodeErrorOptions> {
  public name = 'InvalidRecoveryCodeError';

  toString = () => 'Recovery code is invalid.';
}
